'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLists = setLists;
var SET_LISTS = exports.SET_LISTS = 'SET_LISTS';

function setLists(lists) {
  return {
    type: SET_LISTS,
    payload: lists
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/ExpandableListContainer/actions.js
 ** module id = 468
 ** module chunks = 0
 **/